import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
// 文案函数让 gc_i18n 在语言包加载后执行自动生成的 $t 调用，避免初始化时把中文固化下来。
export const getMenuLabel = menu => {
  if (!menu) return "";
  return typeof menu.label === "function" ? menu.label() : menu.label || "";
};
export const enterpriseHome = {
  link: "/MGT",
  name: "enterpriseHome",
  label: () => $t("e529l3", "工作台"),
  openNames: ["enterpriseHome"],
  icon: "icon-business_gongzuotai_workbench",
  children: []
};
let addressBookRemoveMember = [{
  link: "/MGT/position",
  name: "position",
  label: () => $t("g6mu2", "岗位"),
  openNames: ["addressBook", "position"],
  children: []
}, {
  link: "/MGT/invite",
  name: "invite",
  label: () => $t("pchj2", "邀请"),
  openNames: ["addressBook", "invite"],
  children: []
}, {
  link: "/MGT/unit",
  name: "unit",
  label: () => $t("ely02", "单位"),
  openNames: ["addressBook", "unit"],
  children: []
}];
let addressBook = {
  name: "addressBook",
  label: () => $t("ls4kg3", "通讯录"),
  icon: "icon-user_tongxunlu_address-book",
  children: [{
    link: "/MGT/member",
    name: "member",
    label: () => $t("h5542", "成员"),
    openNames: ["addressBook", "member"],
    children: []
  }]
};
let commonAddressBook = {
  // Enterprise common users enter the address book as a first-level menu.
  link: "/MGT/member",
  name: "addressBook",
  label: () => $t("ls4kg3", "通讯录"),
  openNames: ["addressBook"],
  icon: "icon-user_tongxunlu_address-book",
  children: []
};
export const admin_menu = [{
  ...enterpriseHome
}, {
  ...addressBook,
  children: [...addressBook.children, ...addressBookRemoveMember]
}, {
  name: "safety",
  label: () => $t("gailhf4", "系统安全"),
  icon: "icon-user_renshenanquan_people-safe",
  children: [{
    children: [],
    link: "/MGT/WhiteBlackList",
    name: "blackWhite",
    label: () => $t("kiw14k4", "黑白名单"),
    openNames: ["safety", "unblackWhiteit"]
  }, {
    children: [],
    link: "/MGT/SecuritySetting",
    name: "multiFactor",
    label: () => $t("4prvuf5", "多因素认证"),
    openNames: ["safety", "multiFactor"]
  }]
}, {
  name: "audit",
  label: () => $t("gco02", "审计"),
  icon: "icon-hardware_yinzhang_seal",
  children: [{
    children: [],
    link: "/MGT/audit",
    name: "auditManage",
    label: () => $t("gco02", "审计"),
    openNames: ["audit", "auditManage"]
  }]
}, {
  name: "systemManagement",
  label: () => $t("lydg2", "系统"),
  icon: "icon-Foundation_shezhi_setting_linear",
  children: [{
    children: [],
    link: "/MGT/app-mamage",
    name: "appManager",
    label: () => $t("gqac2", "应用"),
    openNames: ["systemManagement", "appManager"]
  }, {
    children: [],
    link: "/MGT/syncManage",
    name: "syncManage",
    label: () => $t("b1yg4e4", "同步管理"),
    openNames: ["systemManagement", "syncManage"]
  }, {
    children: [],
    link: "/MGT/authManager",
    name: "authManager",
    label: () => $t("op822", "身份"),
    openNames: ["systemManagement", "authManager"]
  }, {
    children: [],
    link: "/MGT/reflection",
    name: "unitMapping",
    label: () => $t("irz0s29", "第三方登录单位映射"),
    openNames: ["systemManagement", "unitMapping"]
  }, {
    children: [],
    name: "myService",
    label: () => $t("cv52iv4", "我的服务"),
    link: "/MGT/services",
    openNames: ["systemManagement", "myService"]
  }]
}];
export const common_menu = [{
  ...enterpriseHome
}, {
  ...commonAddressBook
}];
export const personal_menu = [{
  children: [],
  link: "/MGT/communicationUser",
  name: "addressBook",
  label: () => $t("ls4kg3", "通讯录"),
  icon: "icon-user_tongxunlu_address-book"
}];
export const control = {
  children: [],
  link: "/MGT/services",
  name: "myService",
  label: () => $t("cv52iv4", "我的服务")
};
const SYNC_MANAGEMENT_APP_CODE = "USER_SYNC_MANAGEMENT";
const cloneMenuList = (menus = []) => {
  return menus.map(menu => ({
    ...menu,
    // 进入 Vuex 前解析标签，确保状态中的菜单仍是普通可序列化数据。
    label: getMenuLabel(menu),
    children: cloneMenuList(menu.children || [])
  }));
};

// 同步管理需要工作台可见应用和管理员双权限同时满足，否则从系统菜单中移除。
const filterSyncManageMenu = (menus = [], showSyncManage = false) => {
  return menus.map(menu => {
    if (menu.name !== "systemManagement") return menu;
    return {
      ...menu,
      children: (menu.children || []).filter(child => showSyncManage || child.name !== "syncManage")
    };
  });
};

// 工作台接口返回的 apps 可能只是一层数组，这里兼容应用分组里嵌套 apps 的结构。
const hasVisibleAppCode = (code, apps = []) => {
  return apps.some(app => {
    if (!app) return false;
    if (app.code === code) return true;
    return Array.isArray(app.apps) && hasVisibleAppCode(code, app.apps);
  });
};
export const menuListJs = function (userInfo, visibleApps = []) {
  if (userInfo.unitId) {
    // 企业管理员登录
    if (userInfo.isAdmin === "T") {
      return filterSyncManageMenu(cloneMenuList(admin_menu), hasVisibleAppCode(SYNC_MANAGEMENT_APP_CODE, visibleApps));
    }
    // 普通企业成员登录
    else {
      return cloneMenuList(common_menu);
    }
  }
  // 个人登录
  else {
    return cloneMenuList(personal_menu);
  }
};